var render = function render(_c,_vm){return _c('div',{staticClass:"scroll-container",attrs:{"id":"levyEstimator"}},[_c('v-content',[_c('v-container',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }